import { useTranslation } from 'react-i18next';

const cards = [
  {
    icon: 'ri-table-line',
    titleKey: 'home.value1Title',
    descKey: 'home.value1Desc',
    image:
      'https://readdy.ai/api/search-image?query=A%20clean%20laptop%20screen%20displaying%20a%20colorful%20organized%20product%20spreadsheet%20with%20thumbnail%20images%20and%20columns%20next%20to%20a%20notebook%20and%20coffee%20cup%20on%20a%20light%20wooden%20desk%20bright%20airy%20workspace%20photography%20soft%20daylight%20warm%20neutral%20palette%20crisp%20screen%20detail%20minimal%20composition&width=600&height=400&seq=value-spreadsheet-v2&orientation=landscape&nocache=true',
  },
  {
    icon: 'ri-shield-check-line',
    titleKey: 'home.value2Title',
    descKey: 'home.value2Desc',
    image:
      'https://readdy.ai/api/search-image?query=A%20hand%20holding%20a%20smartphone%20showing%20a%20seller%20profile%20page%20with%20a%20five%20star%20rating%20and%20product%20grid%20in%20the%20background%20a%20soft%20green%20plant%20and%20warm%20neutral%20home%20office%20environment%20shallow%20depth%20of%20field%20clean%20lifestyle%20photography%20trustworthy%20calm%20mood&width=600&height=400&seq=value-sellers-v2&orientation=landscape&nocache=true',
  },
  {
    icon: 'ri-zoom-in-line',
    titleKey: 'home.value3Title',
    descKey: 'home.value3Desc',
    image:
      'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20hands%20inspecting%20the%20stitching%20and%20fabric%20of%20a%20folded%20garment%20under%20a%20bright%20work%20lamp%20on%20a%20white%20inspection%20table%20quality%20control%20concept%20with%20a%20magnifying%20glass%20nearby%20clean%20minimal%20photography%20crisp%20detail%20bright%20clinical%20lighting&width=600&height=400&seq=value-qc-v2&orientation=landscape&nocache=true',
  },
  {
    icon: 'ri-truck-line',
    titleKey: 'home.value4Title',
    descKey: 'home.value4Desc',
    image:
      'https://readdy.ai/api/search-image?query=Stacked%20cardboard%20shipping%20boxes%20with%20a%20tracking%20label%20and%20a%20small%20toy%20delivery%20truck%20on%20a%20soft%20light%20blue%20desk%20background%20clean%20minimal%20logistics%20concept%20photography%20bright%20airy%20lighting%20simple%20composition%20pastel%20tones&width=600&height=400&seq=value-shipping-v2&orientation=landscape&nocache=true',
  },
  {
    icon: 'ri-archive-line',
    titleKey: 'home.value5Title',
    descKey: 'home.value5Desc',
    image:
      'https://readdy.ai/api/search-image?query=A%20neat%20warehouse%20aisle%20with%20tall%20metal%20shelves%20holding%20organized%20cardboard%20boxes%20and%20parcels%20warm%20overhead%20lighting%20clean%20modern%20fulfillment%20center%20photography%20soft%20depth%20perspective%20minimal%20industrial%20yet%20bright%20atmosphere&width=600&height=400&seq=value-warehouse-v2&orientation=landscape&nocache=true',
  },
  {
    icon: 'ri-book-open-line',
    titleKey: 'home.value6Title',
    descKey: 'home.value6Desc',
    image:
      'https://readdy.ai/api/search-image?query=An%20open%20notebook%20with%20handwritten%20checklists%20and%20product%20sketches%20next%20to%20a%20pencil%20and%20a%20tablet%20on%20a%20warm%20cream%20desk%20clean%20study%20and%20planning%20concept%20photography%20soft%20natural%20window%20light%20cozy%20minimal%20editorial%20aesthetic&width=600&height=400&seq=value-guides-v2&orientation=landscape&nocache=true',
  },
];

export default function ValueProps() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            {t('home.valueTitle')}
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
            {t('home.valueSubtitle')}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((card) => (
            <div
              key={card.titleKey}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-40 w-full overflow-hidden">
                <img
                  src={card.image}
                  alt={`${t(card.titleKey)} — AllChinaBuy Spreadsheet resource`}
                  title={`${t(card.titleKey)} AllChinaBuy Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 hover:scale-105"
                />
              </div>
              <div className="p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${card.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                  {t(card.titleKey)}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(card.descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}